module.exports = __webpack_public_path__ + "static/Site-8-d592d8ef3c17bf05d0ea63f3b12d4270.jpg";